import { Component, Host, h, Prop } from '@stencil/core';
import { getAssetSrc } from '../../helpers/helpers';

@Component({
  tag: 'cms-quote',
  styleUrl: 'cms-quote.scss',
  shadow: true,
})
export class CmsQuote {
  private readonly quoteImage = 'quote.svg';

  /**
   * Displayed the quote content
   */
  @Prop() text: string;

  render() {
    return (
      <Host>
        <em class='container'>
          <span
            class='image'
            style={{
              maskImage: `url(${getAssetSrc(this.quoteImage)})`,
              webkitMaskImage: `url(${getAssetSrc(this.quoteImage)})`,
            }}
          />
          <span innerHTML={this.text} class='text' />
        </em>
      </Host>
    );
  }
}
